module.exports = __webpack_public_path__ + "static/media/1.a9da9806.jpg";